module.exports = __webpack_public_path__ + "assets/img/service3.6e1e3907.png";